// PostHog — carga DIFERIDA para no inflar el bundle crítico.
//
// Antes: `import posthog from 'posthog-js'` al top metía toda la librería
// (~grande) en el main bundle, descargándose antes del primer render incluso
// en el móvil más lento. Ahora posthog se carga vía dynamic import cuando el
// navegador está libre (requestIdleCallback) — sale del bundle crítico y
// mejora el TTI. Los eventos disparados antes de que cargue se ENCOLAN y se
// envían en cuanto posthog está listo (no se pierde nada).

let _ph = null;            // instancia de posthog cuando carga
const _cola = [];          // eventos disparados antes de la carga

function _vaciarCola() {
  while (_cola.length) {
    const [metodo, args] = _cola.shift();
    try { _ph[metodo](...args); } catch { /* silencioso */ }
  }
}

// Encola o ejecuta. Si posthog aún no cargó, guarda el evento para después.
function _enviar(metodo, ...args) {
  if (_ph) {
    try { _ph[metodo](...args); } catch { /* silencioso */ }
  } else {
    _cola.push([metodo, args]);
  }
}

function _initDiferido() {
  if (!process.env.REACT_APP_POSTHOG_KEY) return;
  import('posthog-js')
    .then(({ default: posthog }) => {
      posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
        api_host: 'https://app.posthog.com',
        loaded: (ph) => {
          if (process.env.NODE_ENV === 'development') ph.opt_out_capturing();
        },
      });
      _ph = posthog;
      _vaciarCola();
    })
    .catch(() => { /* si falla la red, analytics simplemente no corre */ });
}

// Dispara la carga cuando el navegador esté ocioso (con fallback a setTimeout).
if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(_initDiferido, { timeout: 4000 });
  } else {
    setTimeout(_initDiferido, 2500);
  }
}

const capture  = (evento, props) => _enviar('capture', evento, props);
const identify = (id, datos)     => _enviar('identify', id, datos);

export const track = {
  // Onboarding
  onboardingIniciado:        ()             => capture('onboarding_iniciado'),
  onboardingPasoCompletado:  (paso, d = {}) => capture('onboarding_paso_completado', { paso, ...d }),
  onboardingCompletado:      (d = {})       => capture('onboarding_completado', d),
  onboardingAbandonado:      (paso)         => capture('onboarding_abandonado', { paso }),

  // POS
  ordenCreada:               (d = {})       => capture('orden_creada', d),
  ordenCobrada:              (d = {})       => capture('orden_cobrada', d),
  metodoPagoSeleccionado:    (metodo)       => capture('metodo_pago_seleccionado', { metodo }),

  // Mesas
  mesaOcupada:               (zona)         => capture('mesa_ocupada', { zona }),
  cuentaDividida:            (personas)     => capture('cuenta_dividida', { personas }),

  // Día
  diaAbierto:                ()             => capture('dia_abierto'),
  diaCerrado:                (resumen = {}) => capture('dia_cerrado', resumen),

  // Planes
  upgradePromptMostrado:     (feature, planActual) => capture('upgrade_prompt_mostrado', { feature, planActual }),

  // Identificar negocio al hacer login
  identificarNegocio:        (negocioId, d = {})    => identify(negocioId, d),
};
